import React, { useEffect, useState } from "react";
import { ExportTask, exportProgressService } from "../services/exportProgress";

// Centered, blocking overlay shown while one or more exports are running. It
// replaces transient corner notifications for long/uncertain work so the user
// always has clear, in-context feedback that the export is in progress.
export const ExportProgressOverlay = () => {
  const [tasks, setTasks] = useState<ExportTask[]>(() => exportProgressService.getAll());

  useEffect(() => exportProgressService.onUpdate(setTasks), []);

  if (tasks.length === 0) {
    return null;
  }

  // Show the most recently started task's label; if several run at once, note
  // the count so nothing feels stuck.
  const current = tasks[tasks.length - 1];
  const extra = tasks.length - 1;

  return (
    <div className="export-overlay" role="alertdialog" aria-live="assertive" aria-busy="true">
      <div className="export-overlay-card">
        <span className="export-overlay-spinner" aria-hidden="true" />
        <div className="export-overlay-text">
          <p className="export-overlay-label">{current.label}</p>
          <p className="export-overlay-hint">
            {extra > 0
              ? `${extra + 1} exports in progress — this can take a moment.`
              : "This can take a moment — please keep this tab open."}
          </p>
        </div>
      </div>
    </div>
  );
};
